import React, {useEffect, useState} from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import SinAtencionForm from "./SinAtencionForm";
import {format} from "date-fns";

const SinAtencionEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/fecha-sin-atencion/' + id, {});

  const [formatedData,setFormatedData] = useState(null)

  useEffect(()=>{
    if(data && data.fechaInicio){
      setFormatedData({...data,
        fechaInicio: format(new Date(data.fechaInicio), "yyyy-MM-dd'T'HH:mm:ss"),
        fechaFin: format(new Date(data.fechaFin), "yyyy-MM-dd'T'HH:mm:ss")
      })
    }
  },[data])

  const onUpdate = (sinAtencion) => {
    sinAtencion.id = id;
    sinAtencion.fechaInicio = sinAtencion.fechaInicio + "-05:00"
    sinAtencion.fechaFin = sinAtencion.fechaFin + "-05:00"
    axios.put(Apis.PROD + '/fecha-sin-atencion/update/' + id, sinAtencion)
      .then(res => {
        successToast("Fecha sin atención actualizada correctamente")
        navigate('/sin-atencion')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Fechas sin atención' onClick={() => navigate('/sin-atencion')}/>
        <PageTitle title={'Fecha sin atención'}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <SinAtencionForm value={formatedData} onSubmit={(sinAtencion) => onUpdate(sinAtencion)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default SinAtencionEdit;
